<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <v-tabs
                app
				show-arrows
				:height="32"
				class="tabs-route"
				background-color="transparent"
				slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/subscriptions/' + id + '/'}" key="subscriptions">Abbonamento</v-tab>
                <v-tab exact-path ripple :to="{ path: '/subscriptions/' + id + '/statistics' }" key="statistics">Statistiche</v-tab>
                <v-tab exact-path ripple :to="{ path: '/subscriptions/' + id + '/clis' }" key="clis" v-if="$store.getters.checkModulePermissions('act')">CLI Telefonici</v-tab>
                <v-tab exact-path ripple :to="{ path: '/subscriptions/' + id + '/ddts' }" key="ddts" v-if="$store.getters.checkModulePermissions('ddts')">DDT di Vendita</v-tab>
            </v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :default-input="defaultInput" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>

        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'subscription-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                models: {},
                defaultInput: {}
            }
        },

        computed: {
            entityTitle()  {
                return this.models.subscription ? ['code', 'name'].reduce((acc, key) => this.models.subscription[key] ? acc.concat(this.models.subscription[key]) : acc, []).join(' - ') : ''
            }
        },

        created() {
            this.$store.commit('endProgress')
            this.axios.get('subscriptions/' + this.id).then(response => {
                // get body data
                this.models = response.data.models
                this.defaultInput = {'company_id': this.models.company.id, 'subscription_id': this.id}
                
            }, response => {
                // error callback
            })
        }
    }
</script>